import script from "./modal_sposta.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_sposta.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__